import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getMandateToEdit } from '../../../states/managePayments/selectors';
import { withScrollTop } from '../../../containers/withScrollTop';
import { TYPE_CHAPS, TYPE_IFT } from '../../../config';

const mapState = (state) => ({
	mandate: getMandateToEdit(state),
});

const mandateTypesToEditById = [TYPE_CHAPS, TYPE_IFT];

export class EditPaymentContainer extends Component {
	componentDidMount() {
		const { mandate = {}, handleEditParent, handleEditById } = this.props;
		if (mandateTypesToEditById.includes(mandate.mandateType)) {
			const paymentToEdit = {
				paymentId: mandate.id,
				account: mandate.fromAccount.accountId,
			};
			return handleEditById(mandate.mandateType, paymentToEdit);
		}
		return handleEditParent(mandate);
	}
	render() {
		return null;
	}
}
EditPaymentContainer.propTypes = {
	mandate: PropTypes.shape({
		fromAccount: PropTypes.shape({
			displayName: PropTypes.string.isRequired,
		}),
		display_name: PropTypes.string.isRequired,
		reference: PropTypes.string.isRequired,
	}),
	handleEditParent: PropTypes.func.isRequired,
	handleEditById: PropTypes.func.isRequired,
};

export default connect(mapState)(withScrollTop(EditPaymentContainer));
